/* ============================================================
   Intégrité article <-> frais d'impression dans le panier
   ------------------------------------------------------------
   ⚠️ Ce script ne supprime PLUS aucun fichier. La suppression des
   logos et des aperçus est entièrement gérée par le backend :
   une image jamais rattachée à une commande est effacée
   automatiquement 30 jours après son envoi
   (cf. agent.contexte-stockage-gcs.md). Le thème n'appelle donc
   plus aucun DELETE — ni au retrait d'une ligne, ni ailleurs.

   Rappel du bug de production qui avait motivé la règle précédente
   (agent-bug-suppression-panier.md) : après un paiement, Shopify
   VIDE le panier. Toute logique de suppression pilotée par le
   thème risquait de détruire les fichiers de commandes payées.
   Ne jamais réintroduire de suppression ici.

   Ce qui reste : la resynchronisation des lignes de frais après
   chaque mutation du panier (quantités alignées sur les articles,
   retrait des frais orphelins). Elle agit sur l'état COURANT du
   panier — un panier vidé par un paiement est un no-op.
   ============================================================ */
(function () {
  var busy = false;

  function log() {
    try {
      console.debug.apply(console, ['[pe-cart]'].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* ---------------- Intégrité article <-> frais d'impression ---------------- */
  var enforcing = false;

  function enforceCartIntegrity(cart) {
    if (enforcing) return Promise.resolve();
    var customs = (cart.items || []).filter(function (it) {
      return it.properties && it.properties._design_id;
    });
    var fees = (cart.items || []).filter(function (it) {
      return it.properties && it.properties._fee === 'print';
    });
    if (!customs.length && !fees.length) return Promise.resolve();

    var updates = {};

    // Regroupe par _design_id : en achat groupé, plusieurs lignes (tailles)
    // partagent le même design et le même jeu de lignes de frais.
    var groupsById = {};
    customs.forEach(function (c) {
      var id = c.properties._design_id;
      (groupsById[id] = groupsById[id] || []).push(c);
    });

    Object.keys(groupsById).forEach(function (designId) {
      var group = groupsById[designId];
      var first = group[0];
      var related = fees.filter(function (f) {
        return f.properties._fee_for_design === designId;
      });
      var totalQty = group.reduce(function (n, c) {
        return n + c.quantity;
      }, 0);

      var qtySmallRaw = first.properties._fee_qty_small;
      var qtyLargeRaw = first.properties._fee_qty_large;
      var qtyEmbroideryRaw = first.properties._fee_qty_embroidery;

      if (qtySmallRaw == null && qtyLargeRaw == null && qtyEmbroideryRaw == null) {
        // ancien format (1 frais par article) : aligner la ligne unique
        var fee = related[0];
        if (!fee) {
          group.forEach(function (c) {
            updates[c.key] = 0;
          });
        } else if (fee.quantity !== totalQty) {
          updates[fee.key] = totalQty;
        }
        return;
      }

      // nouveau format : N frais PAR logo, par unité (DTF + broderie).
      // Exception : la numérisation est FIXE — une fois par logo, jamais
      // multipliée par la quantité d'articles.
      var qtyDigitizationRaw = first.properties._fee_qty_digitization;
      var expected = {
        small: (parseInt(qtySmallRaw, 10) || 0) * totalQty,
        large: (parseInt(qtyLargeRaw, 10) || 0) * totalQty,
        embroidery: (parseInt(qtyEmbroideryRaw, 10) || 0) * totalQty,
        digitization: parseInt(qtyDigitizationRaw, 10) || 0,
      };
      var broken = false;

      ['small', 'large', 'embroidery', 'digitization'].forEach(function (size) {
        var line = related.find(function (f) {
          return f.properties._fee_size === size;
        });
        if (expected[size] > 0 && !line) {
          // frais retiré "en douce" => tout le groupe saute
          broken = true;
        } else if (line && line.quantity !== expected[size]) {
          // resynchronise (expected 0 => retire la ligne)
          updates[line.key] = expected[size];
        }
      });

      if (broken) {
        group.forEach(function (c) {
          updates[c.key] = 0;
        });
        // retirer aussi les frais restants de ce groupe
        related.forEach(function (f) {
          updates[f.key] = 0;
        });
      }
    });

    // Frais orphelin (article parent disparu) => on retire le frais.
    fees.forEach(function (f) {
      var parent = customs.find(function (c) {
        return c.properties._design_id === f.properties._fee_for_design;
      });
      if (!parent) updates[f.key] = 0;
    });

    if (Object.keys(updates).length === 0) return Promise.resolve();

    log('intégrité : correction du panier', updates);
    enforcing = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        // sur la page panier, recharger pour que totaux/lignes soient justes
        if (/\/cart(\/|$|\?)/.test(window.location.pathname + '?')) {
          window.location.reload();
        }
      })
      .catch(function () {})
      .then(function () {
        enforcing = false;
      });
  }

  // Ré-applique les styles critiques du remplissage de la barre de rabais
  // après un re-rendu AJAX (les <script> injectés via innerHTML ne s'exécutent pas).
  function forceVdFill() {
    document.querySelectorAll('[data-pe-vd-fill]').forEach(function (el) {
      var pct = parseFloat(el.getAttribute('data-fill')) || 0;
      el.style.setProperty('width', pct + '%', 'important');
      el.style.setProperty('height', '100%', 'important');
      el.style.setProperty('min-height', '10px', 'important');
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('background', 'linear-gradient(90deg,#9d0c23,#d43852)', 'important');
      el.style.setProperty('border-radius', '99px', 'important');
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
    });
  }

  function refreshAfterMutation() {
    if (busy) return;
    busy = true;
    return getCart()
      .then(function (cart) {
        return enforceCartIntegrity(cart);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        setTimeout(forceVdFill, 400);
        setTimeout(forceVdFill, 1200);
      });
  }

  /* ---------------- Détection des mutations du panier ----------------
     Uniquement pour relancer l'intégrité : aucune lecture du corps de la
     requête, aucun instantané, aucune suppression.
  ------------------------------------------------------------------- */
  var MUT = /\/cart\/(add|change|update|clear)/i;

  // --- Patch fetch ---
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (MUT.test(url)) {
        p.then(function () {
          refreshAfterMutation();
        }).catch(function () {});
      }
      return p;
    };
  }

  // --- Patch XMLHttpRequest (certains thèmes / apps l'utilisent) ---
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__peMut = MUT.test(url || '');
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__peMut) {
      this.addEventListener('loadend', function () {
        refreshAfterMutation();
      });
    }
    return origSend.apply(this, arguments);
  };

  function init() {
    getCart()
      .then(function (cart) {
        return enforceCartIntegrity(cart);
      })
      .catch(function () {});
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
